import React, { FunctionComponent } from "react";
import { styled } from "@mui/material/styles";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import { green, grey } from "designSystem/styles/color";
import IconButton, { IconButtonProps } from "designSystem/components/button/IconButton";

const PREFIX = "CommentStatusIcon";

const classes = {
	button: `${PREFIX}button`,
	open: `${PREFIX}open`,
	resolved: `${PREFIX}resolved`,
};

const StyledIconButton = styled(IconButton)((
	{
		theme,
	},
) => ({
	[`&.${classes.button}`]: {
		marginLeft: 4,
	},

	[`& .${classes.open}`]: {
		color: grey[600],
	},

	[`& .${classes.resolved}`]: {
		color: green[500],
	},
}));

interface CommentStatusIconProps extends Omit<IconButtonProps, "children" | "className"> {
	isResolved: boolean;
}

export const CommentStatusIcon: FunctionComponent<CommentStatusIconProps> = (props) => {
	const { isResolved, ...otherProps } = props;


	return (
		<StyledIconButton
			className={classes.button}
			{...otherProps}
			size="large"
		>
			<CheckCircleOutlineIcon className={isResolved ? classes.resolved : classes.open} />
		</StyledIconButton>
	);
};

export default CommentStatusIcon;